module.exports = __webpack_public_path__ + "static/media/ihover.258b5f77.svg";